// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Js_promise from "../../../../../../../../node_modules/rescript/lib/es6/js_promise.js";
import * as Belt_Option from "../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as City$PorterinFeature from "../../../../core/helpers/City.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as CommonStore$PorterinFeature from "../../../../../containers/enterprise/domain/store/CommonStore.mjs";
import * as Lib$PorterinFusionkitSentry from "../../../../../../../../node_modules/@porterin/fusionkit-sentry/src/Lib.mjs";
import * as LocaleHelpers$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/helpers/LocaleHelpers.mjs";
import * as CountryHelpers$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/helpers/CountryHelpers.mjs";
import * as SharedHelper$PorterinFeature from "../../../../core/helpers/SharedHelper.mjs";
import * as CityConstants$PorterinFeature from "../../../../core/constants/CityConstants.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as GetFareEstimate$PorterinFeature from "../../../../fare-estimate/repo/GetFareEstimate.mjs";
import * as AddressConstants$PorterinFeature from "../../../../core/constants/AddressConstants.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../../core/constants/GAEventsConstants.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../../core/helpers/FareEstimateHelper.mjs";
import * as EventsTrackerHelper$PorterinFeature from "../../../../core/helpers/EventsTrackerHelper.mjs";
import * as FareEstimateStoreV1$PorterinFeature from "../../../../../containers/fare-estimate-v1/domain/store/FareEstimateStoreV1.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../../core/helpers/PublishEventsHelper.mjs";
import * as FareEstimateFormStore$PorterinFeature from "../../../../core/constants/FareEstimateFormStore.mjs";
import * as BikesLeadFlowAnalytics$PorterinFeature from "../../../analytics/BikesLeadFlowAnalytics.mjs";
import * as CommonLeadFlowAnalytics$PorterinFeature from "../../../analytics/CommonLeadFlowAnalytics.mjs";
import * as FareEstimateEventHelper$PorterinFeature from "../../../../../containers/fare-estimate-v1/domain/helpers/FareEstimateEventHelper.mjs";
import * as TrucksLeadFlowAnalytics$PorterinFeature from "../../../analytics/TrucksLeadFlowAnalytics.mjs";

function initialFormState(param) {
  return {
          pickup_address: AddressConstants$PorterinFeature.default_address,
          drop_address: AddressConstants$PorterinFeature.default_address,
          name: "",
          mobile: "",
          requirement: undefined,
          consent_for_callback: true
        };
}

function getSource(service_category) {
  return FareEstimateFormStore$PorterinFeature.vehicle_trucks_source;
}

function onFormSubmit(output, callbacks, service_category, category, recaptcha_execute, setPreviousResponse, source, isDesktop, user_city, recaptcha_context, utm_source, utm_campaign, locale, city) {
  var form_data = FareEstimateHelper$PorterinFeature.toApiInput({
        TAG: /* TwoWheelerForm */0,
        _0: {
          pickup_address: output.pickup_address,
          drop_address: output.drop_address,
          name: output.name,
          mobile: output.mobile,
          requirement: output.requirement,
          service_category: service_category,
          consent_for_callback: output.consent_for_callback
        }
      }, undefined, undefined);
  var tripEstimateEventAction = service_category === "2 wheeler" ? CommonStore$PorterinFeature.ga_fare_estimate_successful_2w : CommonStore$PorterinFeature.ga_fare_estimate_successful_trucks;
  var getFormFillSource;
  switch (source) {
    case /* KnowMore */0 :
        getFormFillSource = "knowMore";
        break;
    case /* Desktop */1 :
        getFormFillSource = "";
        break;
    case /* MobileSticky */2 :
        getFormFillSource = "sticky";
        break;
    
  }
  PublishEventsHelper$PorterinFeature.publishEvents(category, GAEventsConstants$PorterinFeature.gaFareEstimateFormValidation, "" + category + "_" + service_category + "_" + output.mobile + "_" + getFormFillSource + "");
  PublishEventsHelper$PorterinFeature.publishEventsV2(CommonLeadFlowAnalytics$PorterinFeature.clickEventName(locale), {
        event_category: category,
        event_label: EventsTrackerHelper$PorterinFeature.getNumberedEventLabel({
              hd: output.name,
              tl: {
                hd: output.mobile,
                tl: {
                  hd: "frequency-" + SharedHelper$PorterinFeature.requirementToString(output.requirement) + "",
                  tl: {
                    hd: utm_source,
                    tl: {
                      hd: utm_campaign,
                      tl: /* [] */0
                    }
                  }
                }
              }
            }),
        language_selected: LocaleHelpers$PorterinUtils.localeToString(locale)
      });
  if (locale === LocaleConstants$PorterinUtils.en_TR || locale === LocaleConstants$PorterinUtils.tr_TR) {
    EventsTrackerHelper$PorterinFeature.publishMoengageEventParameter(FareEstimateStoreV1$PorterinFeature.moe_fare_estimate_result_cta_confirm, {
          vehicle_type: service_category,
          name: output.name,
          phone_number: output.mobile
        });
  }
  Js_promise.$$catch((function (error) {
          Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "VehicleForm - " + error.toString());
          return Promise.resolve(undefined);
        }), Js_promise.then_((function (validator_response) {
              if (validator_response.TAG === /* Ok */0) {
                var match = validator_response._0;
                var callback_request_data = match.callback_request_data;
                var redirect_url = match.redirect_url;
                var geo_region = FareEstimateHelper$PorterinFeature.getParamValue(redirect_url, "geo_region_id", City$PorterinFeature.cityToGeoRegionId(CityConstants$PorterinFeature.dhaka).toString());
                if (callback_request_data.lead_entry_created) {
                  FareEstimateHelper$PorterinFeature.fireGTEEventsOnLeadCreated(redirect_url, form_data.service_category, category, FareEstimateFormStore$PorterinFeature.vehicle_trucks_source, callback_request_data.send_unregistered_event);
                }
                var redirect_url_with_cb_data = redirect_url + FareEstimateHelper$PorterinFeature.makeCallbackDataQueryParams(callback_request_data);
                var validator_response$1 = FareEstimateHelper$PorterinFeature.updateRedirectUrl(validator_response, redirect_url_with_cb_data);
                var updated_form_data_pickup_address = form_data.pickup_address;
                var updated_form_data_drop_address = form_data.drop_address;
                var updated_form_data_name = form_data.name;
                var updated_form_data_mobile = form_data.mobile;
                var updated_form_data_requirement = form_data.requirement;
                var updated_form_data_service_category = form_data.service_category;
                var updated_form_data_consent_for_callback = form_data.consent_for_callback;
                var updated_form_data = {
                  geo_region: geo_region,
                  pickup_address: updated_form_data_pickup_address,
                  drop_address: updated_form_data_drop_address,
                  name: updated_form_data_name,
                  mobile: updated_form_data_mobile,
                  requirement: updated_form_data_requirement,
                  service_category: updated_form_data_service_category,
                  consent_for_callback: updated_form_data_consent_for_callback
                };
                Js_promise.$$catch((function (error) {
                        Curry._1(Lib$PorterinFusionkitSentry.React.captureMessage, "VehicleForm Hash - " + error.toString());
                        return Promise.resolve(undefined);
                      }), Js_promise.then_((function (estimate_secure_response) {
                            if (estimate_secure_response.TAG === /* Ok */0) {
                              var final_redirect_url = estimate_secure_response._0;
                              Curry._1(setPreviousResponse, (function (param) {
                                      return FareEstimateHelper$PorterinFeature.updateRedirectUrl(validator_response$1, final_redirect_url);
                                    }));
                              Curry._1(callbacks.notifyOnSuccess, undefined);
                              PublishEventsHelper$PorterinFeature.publishEvents(category, tripEstimateEventAction, "" + category + "_" + updated_form_data_service_category + "_" + updated_form_data_mobile + "_" + getFormFillSource + "");
                              if (service_category === "2 wheeler") {
                                BikesLeadFlowAnalytics$PorterinFeature.successEvent(category, form_data.name, form_data.mobile, form_data.requirement, utm_source, utm_campaign, form_data.service_category, user_city, locale);
                              } else {
                                TrucksLeadFlowAnalytics$PorterinFeature.successEvent(category, form_data.name, form_data.mobile, form_data.requirement, utm_source, utm_campaign, form_data.service_category, user_city, locale);
                              }
                              if (locale === LocaleConstants$PorterinUtils.en_AE) {
                                PublishEventsHelper$PorterinFeature.publishEventsV2(GAEventsConstants$PorterinFeature.gaFareEstimateSuccessfulV2Uae, {
                                      name: output.name,
                                      mobile_number: output.mobile,
                                      city: Belt_Option.getWithDefault(city, ""),
                                      frequency: "" + SharedHelper$PorterinFeature.requirementToString(output.requirement) + "",
                                      language_selected: LocaleHelpers$PorterinUtils.localeToString(locale)
                                    });
                              }
                              JsBindings$PorterinUtils.redirect(FareEstimateHelper$PorterinFeature.fareEstimateResultRedirectUrlOms(final_redirect_url, form_data.service_category, FareEstimateFormStore$PorterinFeature.vehicle_trucks_source, isDesktop, form_data.consent_for_callback));
                            } else {
                              Curry._1(setPreviousResponse, (function (param) {
                                      return estimate_secure_response;
                                    }));
                              Curry._1(callbacks.notifyOnFailure, estimate_secure_response._0);
                            }
                            return Promise.resolve(undefined);
                          }), GetFareEstimate$PorterinFeature.getFareEstimateHash(redirect_url_with_cb_data, updated_form_data, recaptcha_execute, recaptcha_context, CountryHelpers$PorterinUtils.countryCodeFromLocaleForOms(locale))));
              } else {
                var error = validator_response._0;
                FareEstimateEventHelper$PorterinFeature.publishFareEstimateFormErrorParameter(error);
                PublishEventsHelper$PorterinFeature.publishEvents(Belt_Option.getWithDefault(city, ""), GAEventsConstants$PorterinFeature.gaFareEstimateError + CountryHelpers$PorterinUtils.countryCodeFromLocaleForGa(locale), city);
                Curry._1(setPreviousResponse, (function (param) {
                        return validator_response;
                      }));
                Curry._1(callbacks.notifyOnFailure, error);
              }
              return Promise.resolve(undefined);
            }), GetFareEstimate$PorterinFeature.getFareEstimate(form_data, form_data.service_category, isDesktop, FareEstimateFormStore$PorterinFeature.vehicle_trucks_source, recaptcha_execute, recaptcha_context, CountryHelpers$PorterinUtils.countryCodeFromLocaleForOms(locale))));
}

export {
  initialFormState ,
  getSource ,
  onFormSubmit ,
}
/* City-PorterinFeature Not a pure module */
